import { Input as AntdInput } from 'antd';
import React from 'react';
import styles from './input.module.scss';

const Input = React.forwardRef(
	(
		{
			onChange,
			value,
			placeholder,
			disabled,
			defaultValue,
			type,
			style,
			onPressEnter,
			onBlur,
			id,
			min,
			step,
			prefix,
			allowClear,
			onClear,
			maxLength,
			variant,
		},
		ref,
	) => {
		return (
			<AntdInput
				ref={ref}
				onChange={onChange}
				value={value}
				placeholder={placeholder}
				style={style}
				className={styles['input']}
				disabled={disabled}
				defaultValue={defaultValue}
				type={type}
				onPressEnter={onPressEnter}
				onBlur={onBlur}
				id={id}
				min={min}
				step={step}
				prefix={prefix}
				allowClear={allowClear}
				onClear={onClear}
				maxLength={maxLength}
				variant={variant}
			/>
		);
	},
);

Input.displayName = 'Input'; // helps with debugging in React DevTools

export default Input;
